import message from 'choerodon-ui/lib/message';
export default message;
